import React from 'react';

import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import withMenuEmptyState from 'features/menu/components/with-menu-empty-state';
import MinimalRecentItemsCardList from 'features/menu/pages/recent-items-page/minimal-recent-items';
import RecentOrderCardList from 'features/menu/pages/recent-items-page/recent-order-card-list';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';

const MenuRecentItemsComponent = () => {
  const enableMinimalCartUi = useMinimalCartUi();
  useExposeMinimalCartExperiment();

  return (
    <Box style={styles.container} testID="menu-recents-page">
      {enableMinimalCartUi ? <MinimalRecentItemsCardList /> : <RecentOrderCardList />}
    </Box>
  );
};

export const MenuRecentItemsPage = withMenuEmptyState(MenuRecentItemsComponent);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
